import { render, staticRenderFns } from "./EditRule.vue?vue&type=template&id=5ba13c93&"
import script from "./EditRule.vue?vue&type=script&lang=js&"
export * from "./EditRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports